let failureHandler = () => {};

export function setConnectionFailureHandler(handler) {
    failureHandler = handler;
    return () => { if (failureHandler === handler) failureHandler = () => {}; };
}

function isHtml(data, headers = {}) {
    return typeof data === 'string' &&
        (/text\/html/i.test(headers['content-type'] || '') || /^\s*(?:<!doctype\s+html|<html\b)/i.test(data));
}

export function isUnexpectedApiHtml(response) {
    const config = response && response.config || {};
    const url = String(config.url || '');
    return /^\/(?:api|auth)(?:\/|\?|$)/.test(url) &&
        !['blob', 'arraybuffer', 'document'].includes(config.responseType) &&
        isHtml(response.data, response.headers);
}

export function isConnectionFailure(error) {
    if (!error || error.__CANCEL__ || error.code === 'ERR_CANCELED') return false;
    const response = error.response;
    if (!response) return true;
    return [502, 504].includes(response.status) || isUnexpectedApiHtml(response);
}

export function reportConnectionFailure(error) {
    if (error && error.config && error.config.localErrorHandling) return false;
    if (!isConnectionFailure(error)) return false;
    failureHandler();
    return true;
}
